<template>
    <div class="UiDrawer">
        <div v-if="value" @click="toggleDrawer" style="position: absolute; z-index: 100; left: 0; top: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.4)"></div>
        <div v-if="value" class="p-4" style="z-index: 200; position: fixed; right: 0; top: 0; bottom: 0; max-width: 400px;padding: 0px; background-color: white; border: 1px solid lightgrey;">
            <b-button @click="toggleDrawer" style="cursor: pointer" class="btn-light btn-lg close" squared>
                <i class="zmdi zmdi-close fa-lg"></i>
                <span class="sr-only">{{ $t('global.cancel') }}</span>
            </b-button>

            <h6 class="mb-4 pt-1 text-lg">{{ title }}</h6>

            <slot></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: "UiDrawer",
    props: {
        title: {
            type: String,
            default: ''
        },
        value: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        toggleDrawer: function() {
            this.$emit("input", !this.value)
        }
    }
}
</script>
